import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { db } from "../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";

export default function InvoicePage() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const feeIndex = searchParams.get("fee");

    const [student, setStudent] = useState(null);
    const [fee, setFee] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const snap = await getDoc(doc(db, "students", id));

            if (snap.exists()) {
                const data = snap.data();
                setStudent(data);
                setFee(data.feesReceived[feeIndex]);
            }
        };

        fetchData();
    }, [id, feeIndex]);

    if (!student || !fee) return <div>Loading...</div>;

    // 💰 GST CALCULATION
    const amount = Number(fee.amount);
    const gstAmount = (amount * 18) / 118;
    const baseAmount = amount - gstAmount;

    return (
        <div className="p-6 bg-white text-black max-w-4xl mx-auto">

            {/* HEADER */}
            <div className="flex justify-between items-center border-b pb-4">
                <div>
                    <h1 className="text-2xl font-bold">SkillAura Institute</h1>
                    <p>Ludhiana, Punjab</p>
                    <p>Phone: 8264212710</p>
                </div>

                <div className="text-right">
                    <h2 className="text-xl font-bold">TAX INVOICE</h2>
                    <p>Date: {fee.receiveDate}</p>
                    <p>Invoice No: INV-{id?.slice(0, 5)}-{feeIndex}</p>
                </div>
            </div>

            {/* CUSTOMER DETAILS */}
            <div className="grid grid-cols-2 gap-6 mt-6 border-b pb-4">

                <div>
                    <h3 className="font-semibold mb-2">Customer Details</h3>
                    <p><strong>Name:</strong> {student.fullName}</p>
                    <p><strong>Phone:</strong> {student.mobile}</p>
                    <p><strong>Email:</strong> {student.email}</p>
                    <p><strong>Address:</strong> {student.address}</p>
                </div>

                <div>
                    <h3 className="font-semibold mb-2">Course Details</h3>
                    <p><strong>Course:</strong> {student.course}</p>
                    <p><strong>Start Date:</strong> {student.classStartDate}</p>
                    <p><strong>Status:</strong> {student.status}</p>
                </div>

            </div>

            {/* TABLE */}
            <table className="w-full mt-6 border text-sm">
                <thead className="bg-gray-200">
                    <tr>
                        <th className="border p-2">#</th>
                        <th className="border p-2">Description</th>
                        <th className="border p-2">Amount</th>
                        <th className="border p-2">GST (18%)</th>
                        <th className="border p-2">Total</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td className="border p-2 text-center">1</td>
                        <td className="border p-2">
                            Course Fee - {student.course}
                        </td>
                        <td className="border p-2 text-center">
                            ₹{Math.round(baseAmount)}
                        </td>
                        <td className="border p-2 text-center">
                            ₹{Math.round(gstAmount)}
                        </td>
                        <td className="border p-2 text-center">
                            ₹{amount}
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* TOTAL */}
            <div className="mt-6 flex justify-end">
                <div className="w-64 space-y-2">
                    <p>Base Amount: ₹{Math.round(baseAmount)}</p>
                    <p>GST: ₹{Math.round(gstAmount)}</p>
                    <p className="font-bold text-lg">
                        Total: ₹{amount}
                    </p>
                </div>
            </div>

            {/* FOOTER */}
            <div className="mt-10 border-t pt-4 text-sm">
                <p>Payment Mode: {fee.paymentMode}</p>
                <p>Reference: {fee.reference}</p>

                <div className="mt-6 flex justify-between">
                    <p>Customer Signature</p>
                    <p>Authorized Signatory</p>
                </div>
            </div>

        </div>
    );
}